import React, { Component } from 'react';
import Portal from '~/UI/Portal/Portal';

import styles from './styles.less';

interface Props {
	onSelect(index: number): void;
	onOptionClick(index: number): void;
	options: { id: string; title: string }[];
	selectedIndex: number;
	selectedOptionIds: Set<string>;
	autoscroll: boolean;
	referenceRect: {
		left: number;
		top: number;
		bottom: number;
		width: number;
	} | null;
	onFocus(): void;
	onBlur(): void;
}

export default class AutocompletePopover extends Component<Props> {
	static defaultProps = {
		autoscroll: false,
		referenceRect: null,
	};

	selectedItemElement: HTMLLIElement | null = null;

	componentDidMount() {
		this.scrollOnSelectedOption();
	}

	componentDidUpdate(prevProps: Props) {
		const { selectedIndex, autoscroll } = this.props;

		if (autoscroll && selectedIndex !== prevProps.selectedIndex) {
			this.scrollOnSelectedOption();
		}
	}

	scrollOnSelectedOption() {
		if (this.selectedItemElement !== null) {
			this.selectedItemElement.scrollIntoView(false);
		}
	}

	render() {
		const { onSelect, onOptionClick, options, selectedIndex, selectedOptionIds, referenceRect, onFocus, onBlur } =
			this.props;
		if (referenceRect === null || referenceRect === undefined) {
			return null;
		}

		const style: { position: 'absolute'; left: number; top: number; width: number } = {
			position: 'absolute',
			left: referenceRect.left,
			top: referenceRect.bottom,
			width: referenceRect.width,
		};

		return (
			<Portal>
				<div className={styles.popover} style={style} onBlur={onBlur} onMouseDown={onFocus} onMouseOut={onBlur}>
					<ul className={styles.list}>
						{options.map((option, index) => {
							const isSelected = selectedOptionIds.has(option.id);
							const isFocused = selectedIndex === index;
							const className = `${isFocused ? 'focused-' : ''}${
								isSelected ? 'selected-' : ''
							}item` as keyof (typeof styles)['locals'];

							return (
								<li
									className={styles[className]}
									key={option.id}
									ref={isFocused ? (ref) => (this.selectedItemElement = ref) : null}
									role='presentation'
									onMouseDown={() => onOptionClick(index)}
									onMouseEnter={() => onSelect(index)}
								>
									{option.title}
								</li>
							);
						})}
					</ul>
				</div>
			</Portal>
		);
	}
}
